$(() => {
  const key1 = 'show-file-info';
  const key2 = 'file-info-container';
  const key3 = 'rm-item';
  const dataTransfer = new DataTransfer();
  let counter = 0;

  $(`input[data-${key1}]`).on('change', function () {
    const $this = $(this);
    $.each($(this.files), function (index, val) {
      $($this.data(key1)).append(
        `<li><div class='d-flex align-items-center bg-light rounded mb-1 py-1 px-3'><div>${
          val.name
        } (${Math.ceil(
          val.size / 1024
        )}kB)</div><div class='ms-auto cursor-pointer' data-${key3}=${
          dataTransfer.files.length
        }>×</div></div></li>`
      );
      dataTransfer.items.add(val);
    });
    $(this).prop('files', dataTransfer.files);
    $($this.data(key2)).removeClass('d-none');
  });

  $(document).on('click', `[data-${key3}]`, function () {
    dataTransfer.items.remove($(this).data(key3));
    $(this).closest('li').remove();
    $(`input[data-${key1}]`).prop('files', dataTransfer.files);
    $(`[data-${key3}]`).each(function (index) {
      $(this).attr(`data-${key3}`, index);
    });
  });
});
